import { Injectable } from '@angular/core';
import { IIDolActivationRequestStore } from './iidOlActivationRequest.store';
import { IID_OL_ACTIVATION_REQUEST } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { IIDolActivationRequestQuery } from './iidOlActivationRequest.query';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IBuildingInfos, IGisfoSearchBuilidingResponse } from '@common/interfaces/gisfo';
import { WsACKCallback } from '@common/api/ack';
import { RealtimeFeatureCommandService } from '@ep-om/realtime-v2';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';
@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.ACTIVATION_REQUEST)
export class IIDolActivationRequestService extends CrudService<IID_OL_ACTIVATION_REQUEST, IIDolActivationRequestStore, IIDolActivationRequestQuery> {
  constructor(
    protected store: IIDolActivationRequestStore,
    public query: IIDolActivationRequestQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
    private featureCommandService: RealtimeFeatureCommandService,
  ) {
    super(Topics.IID_OL_ACTIVATION_REQUEST, store, query, actionService, updateStrategy);
  }

  searchBuildings(buildingInfos: IBuildingInfos, callback?: WsACKCallback<IGisfoSearchBuilidingResponse>) {
    this.featureCommandService.send<IGisfoSearchBuilidingResponse>(
      {
        target: 'feature:ol-activation-request',
        command: 'search-buildings',
        dto: buildingInfos,
      },
      () => this.actionService.sendMessage(Topics.IID_OL_ACTIVATION_REQUEST, 'searchBuildings', buildingInfos, callback),
      callback,
    );
  }
}
